/* IceBeanie PDP v2 — behavior
   Ported from the client mockup, wired to real Shopify data:
   - tier selection drives the active variant + all price displays (hero, sticky, final)
   - color swatch resolves the variant within the selected tier's product
   - Add-To-Cart posts to /cart/add.js and opens the gamified sticky cart (window.EWCart);
     falls back to the /cart redirect when the drawer is disabled
   - gallery thumbs, FAQ accordion, scroll reveal, sticky ATC visibility
   Namespaced hooks ([data-pdp2-*]) so it never double-binds with ew-cart.js.        */
(function () {
  // The theme editor (and Shopify's section rendering) REPLACES the section's DOM after load.
  // This script used to wire itself once at parse time, so after a re-render the fresh thumbs
  // arrived unfiltered and with no handlers. Everything now lives in initPdp2(), which re-runs
  // whenever a section is (re)rendered. `lastRoot` keeps it idempotent: a section:load event for
  // some other section leaves our still-wired DOM untouched instead of double-binding it.
  var lastRoot = null;

  function initPdp2() {
  var root = document.querySelector('.pdp2');
  // Build marker: lets you confirm from the console which version of this file the page loaded.
  window.PDP2_BUILD = 'gallery-strict-v6';
  if (!root) return;
  if (root === lastRoot) return;
  lastRoot = root;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money0 = function (c) { return (c / 100); };
  function fmt(cents) {
    // Shopify money format without the theme filter (client-side). USD assumed; adjust if multi-currency.
    return '$' + money0(cents).toFixed(2);
  }

  /* -------- STATE -------- */
  var state = { color: (root.querySelector('[data-pdp2-swatch].active') || {}).getAttribute
                  ? (root.querySelector('[data-pdp2-swatch].active').getAttribute('data-color') || 'default')
                  : 'default',
                tier: null };

  function tierEls() { return Array.prototype.slice.call(root.querySelectorAll('[data-pdp2-tier]')); }

  function variantForTier(tierEl) {
    var map = {};
    try { map = JSON.parse(tierEl.getAttribute('data-variants') || '{}'); } catch (e) {}
    var key = (state.color || 'default').toLowerCase();
    return map[key] || map['default'] || map[Object.keys(map)[0]] || null;
  }

  function paint() {
    tierEls().forEach(function (t) {
      var on = t.getAttribute('data-name') === (state.tier && state.tier.getAttribute('data-name'));
      t.classList.toggle('active', !!on);
    });
    if (!state.tier) return;
    var v = variantForTier(state.tier);
    var name = state.tier.getAttribute('data-name') || '';
    var price = v ? v.price : parseInt(state.tier.getAttribute('data-price') || '0', 10);
    var compare = v ? (v.compare || 0) : parseInt(state.tier.getAttribute('data-compare') || '0', 10);
    var each = state.tier.getAttribute('data-each') || '';

    set('#pdp2-price-now', fmt(price));
    var was = root.querySelector('#pdp2-price-was'), save = root.querySelector('#pdp2-price-save'),
        eachEl = root.querySelector('#pdp2-price-each');
    if (compare && compare > price) {
      if (was) { was.textContent = fmt(compare); was.style.display = ''; }
      if (save) { save.textContent = 'Save ' + Math.round((1 - price / compare) * 100) + '%'; save.style.display = ''; }
    } else {
      if (was) was.style.display = 'none';
      if (save) save.style.display = 'none';
    }
    if (eachEl) { if (each) { eachEl.textContent = each + ' each'; eachEl.style.display = ''; } else eachEl.style.display = 'none'; }

    set('#pdp2-sticky-name', name); set('#pdp2-sticky-price', fmt(price));
    set('#pdp2-final-name', name);  set('#pdp2-final-total', fmt(price));

    // resolve ATC targets
    var vid = v ? v.id : (state.tier.getAttribute('data-default-variant') || '');
    var avail = v ? v.available : true;
    root.querySelectorAll('[data-pdp2-atc]').forEach(function (b) {
      b.setAttribute('data-variant', vid);
      if (!avail || !vid) { b.disabled = true; b.dataset._lbl = b.dataset._lbl || b.textContent; b.textContent = 'Sold out'; }
      else { b.disabled = false; if (b.dataset._lbl) b.textContent = b.dataset._lbl; }
    });
  }
  function set(sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; }

  /* -------- TIERS -------- */
  tierEls().forEach(function (t) {
    t.setAttribute('tabindex', '0');
    function pick() { state.tier = t; paint(); }
    t.addEventListener('click', pick);
    t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    if (t.classList.contains('active')) state.tier = t;
  });
  if (!state.tier) state.tier = tierEls()[0] || null;

  /* -------- GALLERY -------- */
  var stage = root.querySelector('#pdp2-stage');
  var thumbWrap = root.querySelector('#pdp2-thumbs');
  function setStage(url) { if (stage && url) stage.style.backgroundImage = "url('" + url + "')"; }
  function allThumbs() { return thumbWrap ? Array.prototype.slice.call(thumbWrap.querySelectorAll('[data-img]')) : []; }

  /* Show only the thumbs belonging to `color` (plus untagged, shared ones) and promote the
     first of them to the stage. If no thumb carries that colour - e.g. the catalogue has no
     colour in its alt text yet - every thumb stays visible, so nothing regresses. */
  function applyColorGallery(color, setHero) {
    var thumbs = allThumbs();
    if (!thumbs.length) return;
    var max = parseInt((thumbWrap.getAttribute('data-thumbs-max') || '5'), 10) || 5;
    function colorOf(t) { return t.getAttribute('data-color') || ''; }
    var tagged = thumbs.filter(function (t) { return colorOf(t) !== ''; });
    var mine = thumbs.filter(function (t) { return colorOf(t) === color; });
    var untagged = thumbs.filter(function (t) { return colorOf(t) === ''; });

    // STRICT per-colour gallery: when this colour owns images, ONLY those are shown -
    // no images from another colour, and no untagged shots mixed in.
    var visible;
    if (mine.length) visible = mine;                 // normal case
    else if (!tagged.length) visible = thumbs;       // catalogue has no colour alt text yet
    else if (untagged.length) visible = untagged;    // this colour has none: generic shots only
    else visible = thumbs;                           // last resort, never leave the gallery empty
    visible = visible.slice(0, max);

    thumbs.forEach(function (t) {
      var on = visible.indexOf(t) !== -1;
      // A plain inline style LOSES to any stylesheet rule marked !important (an app or a later
      // theme edit with e.g. `.thumb{display:block!important}` silently undid the filter).
      // Inline + !important has the highest precedence there is, so it cannot be overridden.
      if (on) {
        t.style.removeProperty('display');
        t.removeAttribute('hidden');
        t.classList.remove('pdp2-off');
      } else {
        t.style.setProperty('display', 'none', 'important');
        t.setAttribute('hidden', '');
        t.classList.add('pdp2-off');
        t.classList.remove('active');
      }
    });
    if (!visible.length) return;
    if (setHero) {
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      visible[0].classList.add('active');
      setStage(visible[0].getAttribute('data-img'));
    } else if (!visible.some(function (t) { return t.classList.contains('active'); })) {
      // On load the thumb Liquid marked active may now be hidden: highlight the first visible
      // one, but leave the hero image Liquid rendered from the selected variant alone.
      visible[0].classList.add('active');
    }
  }

  allThumbs().forEach(function (t) {
    function go() {
      allThumbs().forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active'); setStage(t.getAttribute('data-img'));
    }
    t.addEventListener('click', go);
    t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
  });

  /* -------- SWATCHES (color) -------- */
  root.querySelectorAll('[data-pdp2-swatch]').forEach(function (s) {
    s.addEventListener('click', function () {
      root.querySelectorAll('[data-pdp2-swatch]').forEach(function (x) { x.classList.remove('active'); });
      s.classList.add('active');
      state.color = s.getAttribute('data-color') || 'default';
      applyColorGallery(state.color, true);
      // The swatch's own image wins when the product has one pinned to that colour.
      var img = s.getAttribute('data-img');
      if (img) setStage(img);
      paint();
    });
  });

  // Initial state: filter to the colour that is active on load, without stealing the hero image
  // that Liquid already rendered from the selected variant.
  applyColorGallery(state.color, false);
  // Apps and late scripts can still touch the gallery after DOMContentLoaded: re-apply on load.
  window.addEventListener('load', function () { applyColorGallery(state.color, false); });

  /* -------- SELF-DIAGNOSTIC --------
     The colour grouping lives in the LIQUID (data-color on each thumb). If only this JS file was
     updated, there is nothing to filter on and the gallery silently shows everything. Say so. */
  (function () {
    var ts = allThumbs();
    var withColor = ts.filter(function (t) { return (t.getAttribute('data-color') || '') !== ''; });
    var sw = root.querySelectorAll('[data-pdp2-swatch]').length;
    if (!ts.length) return;
    if (!withColor.length) {
      console.warn('[PDP2 ' + window.PDP2_BUILD + '] ' + ts.length + ' thumbs, ' + sw +
        ' swatches, but NONE carry data-color.\n' +
        '=> sections/ew-pdp-v2.liquid is NOT the updated one (the JS alone cannot group by colour).\n' +
        '=> Showing the full gallery as a fallback.');
      return;
    }
    // Compare what we asked for with what the browser really renders.
    var wanted = ts.filter(function (t) { return !t.classList.contains('pdp2-off'); }).length;
    var shown = ts.filter(function (t) { return getComputedStyle(t).display !== 'none'; }).length;
    if (shown !== wanted) {
      var leak = ts.filter(function (t) { return t.classList.contains('pdp2-off') && getComputedStyle(t).display !== 'none'; })[0];
      console.warn('[PDP2 ' + window.PDP2_BUILD + '] filter asked for ' + wanted + ' visible thumbs but ' +
        shown + ' are rendered. Something is forcing display on hidden thumbs ' +
        '(computed display: "' + (leak ? getComputedStyle(leak).display : '?') + '"). Inspect one in DevTools > Styles.');
    } else {
      console.info('[PDP2 ' + window.PDP2_BUILD + '] OK - ' + withColor.length + '/' + ts.length +
        ' thumbs tagged, colour "' + state.color + '", showing ' + shown + '/' + ts.length + '.');
    }
  })();

  /* -------- ADD TO CART (AJAX -> /cart) -------- */
  function cartAdd(id, qty) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: +(qty || 1) }] })
    });
  }
  root.querySelectorAll('[data-pdp2-atc]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var id = b.getAttribute('data-variant');
      if (!id) return;
      var qEl = root.querySelector('#pdp2-qty-value');
      var qty = qEl ? parseInt(qEl.textContent, 10) : 1;
      var lbl = b.textContent; b.textContent = 'Adding…'; b.disabled = true;
      // Gamified sticky cart present -> add + open the drawer (no /cart redirect)
      if (window.EWCart && typeof window.EWCart.add === 'function') {
        window.EWCart.add([{ id: +id, quantity: +qty }]).then(function () {
          b.textContent = 'Added ✓';
          setTimeout(function () { b.textContent = lbl; b.disabled = false; }, 1200);
        }).catch(function () { b.textContent = lbl; b.disabled = false; });
        return;
      }
      cartAdd(id, qty).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        b.textContent = 'Added ✓';
        setTimeout(function () { window.location.href = window.Shopify.routes.root + 'cart'; }, 350);
      }).catch(function () { b.textContent = lbl; b.disabled = false; });
    });
  });

  /* -------- QUANTITY (hero) -------- */
  (function () {
    var v = root.querySelector('#pdp2-qty-value');
    var minus = root.querySelector('#pdp2-qty-minus'), plus = root.querySelector('#pdp2-qty-plus');
    if (!v) return;
    if (minus) minus.addEventListener('click', function () { v.textContent = Math.max(1, parseInt(v.textContent, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { v.textContent = parseInt(v.textContent, 10) + 1; });
  })();

  /* -------- FAQ ACCORDION -------- */
  root.querySelectorAll('.acc .item').forEach(function (item) {
    var btn = item.querySelector('button'), panel = item.querySelector('.panel');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = item.classList.contains('open');
      item.classList.toggle('open');
      panel.style.maxHeight = open ? 0 : panel.scrollHeight + 'px';
    });
  });

  /* -------- UGC VIDEO -------- */
  (function () {
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-pdp2-ugc]'));
    if (!tiles.length) return;

    function stop(tile) {
      var host = tile.querySelector('.ugc-media');
      if (!host) return;
      var v = host.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} }
      host.parentNode.removeChild(host); // drops the iframe too, killing its audio
      tile.classList.remove('is-playing');
      tile.setAttribute('aria-pressed', 'false');
    }

    function play(tile) {
      var tpl = tile.querySelector('[data-pdp2-ugc-media]');
      if (!tpl || tile.classList.contains('is-playing')) return;

      tiles.forEach(function (t) { if (t !== tile) stop(t); }); // one at a time

      var host = document.createElement('div');
      host.className = 'ugc-media';
      host.appendChild(tpl.content.cloneNode(true));
      tile.appendChild(host);
      tile.classList.add('is-playing');
      tile.setAttribute('aria-pressed', 'true');

      // Called synchronously inside the click handler, so the user gesture still
      // applies and unmuted playback is allowed.
      var v = host.querySelector('video');
      if (v) {
        var p = v.play();
        if (p && p.catch) {
          p.catch(function () { v.muted = true; v.play().catch(function () {}); });
        }
      }
    }

    tiles.forEach(function (tile) {
      if (!tile.querySelector('[data-pdp2-ugc-media]')) return; // poster only
      tile.setAttribute('aria-pressed', 'false');
      tile.addEventListener('click', function () { play(tile); });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault(); play(tile);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) tiles.forEach(stop);
    });
  })();

  /* -------- STICKY ATC -------- */
  var sticky = document.getElementById('pdp2-sticky'), hero = root.querySelector('.hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      en.forEach(function (x) { sticky.classList.toggle('show', !x.isIntersecting); });
    }, { rootMargin: '-140px 0px 0px 0px' }).observe(hero);
  }

  /* -------- SCROLL REVEAL -------- */
  if (!reduce && 'IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); } });
    }, { threshold: .12 });
    root.querySelectorAll('.reveal').forEach(function (el) { ro.observe(el); });
  } else {
    root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  paint();
  }

  initPdp2();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPdp2);
  document.addEventListener('shopify:section:load', initPdp2);
  document.addEventListener('shopify:section:select', initPdp2);
})();